<div
  *ngIf="loader.getLoading()"
  role="status"
  class="absolute z-50 flex h-screen w-screen items-center justify-center bg-black bg-opacity-75">
  <img src="assets/images/logos/logo.svg" alt="logo" class="animate-spin" />
  <span class="sr-only">Loading...</span>
</div>
